import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'revenueCategory'];

  connect() {
    this.API_BASE_URL = '/sandbar/admin'
    this.disableRevenueCategory();
    this.populateRevenueCategories()
  }

  handleMenuChanged() {
    this.disableRevenueCategory();
    this.populateRevenueCategories();
  }

  disableRevenueCategory() {
    this.revenueCategoryTarget.disabled = true;
  }

  enableRevenueCategory() {
    this.revenueCategoryTarget.disabled = false;
  }

  async populateRevenueCategories() {
    this.revenueCategoryTarget.innerHTML = null;
    const categories = await this.fetchRevenueCategories();
    const categoryId = this.revenueCategoryTarget.dataset.categoryid

    this.revenueCategoryTarget.add(new Option('None', '', false, false));
    categories.forEach(category => {
      this.revenueCategoryTarget.add(new Option(category.name, category.id, false, categoryId === category.id.toString()));
    });
    this.enableRevenueCategory();
  }

  async fetchRevenueCategories() {
    try {
      const menu_id = this.hasMenuTarget ? this.menuTarget.value : this.revenueCategoryTarget.dataset.menuid
      const response = await fetch(`${this.API_BASE_URL}/revenue_categories.json?menu_id=${menu_id}`)
      return response.json();
    } catch (err) {
      console.error(err);
      return [];
    }
  }

}
